(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-7"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root = document.currentScript && document.currentScript.previousElementSibling;
    var section = document.querySelector('[id^="s7main-"]');
    if(!section) return;

    var stage = section.querySelector('[data-s7g-stage]');
    var thumbs = section.querySelectorAll('[data-s7g-thumb]');
    var qtyInput = section.querySelector('[data-s7b-qty]');
    var savings = section.querySelector('[data-s7b-savings]');
    var atcBtn = section.querySelector('[data-s7b-atc]');
    var bundles = section.querySelectorAll('[data-s7b-bundle]');

    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = parseInt(t.dataset.s7gThumb, 10);
        var slide = stage.querySelector('[data-s7g-slide="'+i+'"]');
        if(slide){ stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); }
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    if(stage){
      stage.addEventListener('scroll', function(){
        var i = Math.round(stage.scrollLeft / stage.clientWidth);
        thumbs.forEach(function(x){ x.classList.toggle('is-active', parseInt(x.dataset.s7gThumb,10) === i); });
      }, { passive: true });
    }

    function updateSavings(qty, price){
      var base = 695;
      var save = (base - (price / qty)) * qty;
      if(savings){ savings.innerHTML = 'Ahorras <strong>$' + save.toLocaleString('es-MX') + ' MXN</strong> hoy'; }
    }

    bundles.forEach(function(b){
      b.addEventListener('click', function(){
        bundles.forEach(function(x){ x.classList.remove('is-selected'); });
        b.classList.add('is-selected');
        var radio = b.querySelector('input[type="radio"]');
        if(radio){ radio.checked = true; }
        var q = parseInt(b.dataset.qty, 10) || 1;
        var p = parseInt(b.dataset.price, 10) || 595;
        if(qtyInput){ qtyInput.value = q; }
        updateSavings(q, p);
      });
    });

    var initial = section.querySelector('[data-s7b-bundle].is-selected');
    if(initial){
      var q = parseInt(initial.dataset.qty, 10) || 2;
      var p = parseInt(initial.dataset.price, 10) || 1090;
      if(qtyInput){ qtyInput.value = q; }
      updateSavings(q, p);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s7-features"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var section = document.querySelector('[id^="s7f-"]');
    if(!section) return;
    var tabs = section.querySelectorAll('[data-s7f-tab]');
    var panels = section.querySelectorAll('[data-s7f-panel]');
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = t.dataset.s7fTab;
        tabs.forEach(function(x){ x.classList.remove('is-active'); });
        panels.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var panel = section.querySelector('[data-s7f-panel="'+i+'"]');
        if(panel) panel.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
